import { render, staticRenderFns } from "./commonTagFilter.vue?vue&type=template&id=678ceba8&scoped=true"
import script from "./commonTagFilter.vue?vue&type=script&lang=js"
export * from "./commonTagFilter.vue?vue&type=script&lang=js"
import style0 from "./commonTagFilter.vue?vue&type=style&index=0&id=678ceba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678ceba8",
  null
  
)

export default component.exports